<template>
  <div class="dynamic">
    <Form v-if="searchItems.length" :items="searchItems" :isShow="searchShow" @on-submit="handleSearch"
      @on-clear="handleSearch" />
    <div class="btns">
      <div class="l">
        <span class="title">{{column.cplabel}}</span>
        <el-button v-if="addBtn" type="primary" size="mini" icon="el-icon-plus" @click="handleRowAdd">新增</el-button>
        <template v-if="extMenu2">
          <el-button v-for="(item, i) in extMenu2" :key="i" :type="item.buttonStyleType ? item.buttonStyleType : 'text'"
            :icon="item.icon" @click.stop="handleExtEvent(null, item)">
            {{item.name}}
          </el-button>
        </template>
      </div>
      <div class="r">
        <el-button v-if="searchItems.length" icon="el-icon-search" circle @click="handleShowForm"></el-button>
      </div>
    </div>
    <!-- :data="filterList.length ? filterColumn : tableColumn" -->
    <el-table :span-method="mergeCell" :data="tableColumn" border fit size="small" style="width: 100%">
      <el-table-column type="expand" v-if="expandColumn.length > 0">
        <template slot-scope="{row}">
          <el-form label-position="left" class="table-expand" :key="i" v-for="(subItem, i) in expandColumn">
            <el-form-item :label="subItem.label + ':'">
              <span>{{ row[subItem.prop] }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <template v-slot:empty>
        <div class="empty" style="padding-top: 50px;"><img style="height: 50px;"
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K" />
        </div>
        <div class="empty" style="padding-bottom: 50px;">暂无数据</div>
      </template>
      <el-table-column v-if="column.index" align="center" label="#" type="index" width="50" />
      <!-- :show-overflow-tooltip="true" -->
      <template v-for="(item, i) in items">
        <el-table-column v-if="item.filters" :key="i" :fixed="item.fixed ? item.fixed : null" align="center"
          :prop="item.prop" :sort-method="sortChange" :sortable="isViewPage && item.sortable ? true : false"
          :width="item.width ? item.width : ''" :label="item.label" :filters="filtersArr(item)"
          :filter-method="handleFilter">
          <!-- <template slot="header" slot-scope="scope">
          <Filters :scope="scope" :item="item" :tableColumn="tableColumn" @on-filter="handleFilter" />
        </template> -->
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="top"
              v-if="['input', 'textarea'].includes(item.type) && item.disabled && item.showTip">
              <div class="content" slot="content">{{scope.row[item.prop]}}</div>
              <div class="cell2">{{scope.row[item.prop]}}</div>
            </el-tooltip>
            <Item v-else :item="item" :scope="scope" @on-edit="handleRowEdit" />
          </template>
        </el-table-column>
        <el-table-column v-else :key="i" :fixed="item.fixed ? item.fixed : null" align="center" :prop="item.prop"
          :sort-method="sortChange" :sortable="isViewPage && item.sortable ? true : false"
          :width="item.width ? item.width : ''" :label="item.label">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="top"
              v-if="['input', 'textarea'].includes(item.type) && item.disabled && item.showTip">
              <div class="content" slot="content">{{scope.row[item.prop]}}</div>
              <div class="cell2">{{scope.row[item.prop]}}</div>
            </el-tooltip>
            <Item v-else :item="item" :scope="scope" @on-edit="handleRowEdit" />
          </template>
        </el-table-column>
      </template>
      <el-table-column v-if="delBtn || extMenu1.length > 0" fixed="right" align="center" label="操作" :width="menuWidth">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope)" type="text" size="small">查看</el-button> -->
          <!-- <el-button type="text" size="small" @click="handleRowEdit(scope)">编辑</el-button> -->
          <el-button v-if="delBtn" type="text" size="small"
            @click.native.prevent="handleRowDel(scope.$index)">删除</el-button>
          <el-button v-for="(item, i) in extMenu1" :key="i" :type="item.buttonStyleType ? item.buttonStyleType : 'text'"
            :icon="item.icon" @click.stop="handleExtEvent(scope, item)">
            {{item.name}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="avue-crud__pagination" v-if="isPage">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </div>

    <el-dialog :closeOnClickModal="false" :title="dialogItem.name || '标题'" :visible.sync="dialogVisible"
      :width="dialogItem.fullscreen !== true ? dialogItem.width : ''" :style="{height: ''}" append-to-body="true"
      :fullscreen="dialogItem.fullscreen">
      <iframe :src="dialogItem.iframeURL ? dialogItem.iframeURL : '#'" class="iframe" ref="iframe"
        :style="`height:${dialogItem.height}`"></iframe>
      <span slot="footer" class="dialog-footer" v-if="dialogItem.confirmName || dialogItem.cancelName">
        <el-button @click="dialogVisible = false" v-if="dialogItem.cancelName">{{dialogItem.cancelName}}</el-button>
        <el-button type="primary" @click="handleIframeConfirm"
          v-if="dialogItem.confirmName">{{dialogItem.confirmName}}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入数据" @close="importExcelClose" :visible.sync="uploadView.show" width="30%" top="15vh"
      :append-to-body="true">
      <el-row>
        <el-form :inline="true" ref="uploadView" :model="uploadView.form" label-suffix=":">
          <el-col :span="24">
            <input type="file" ref="referenceUpload" class="file" @change="uploading($event)">
            <el-button type="success" class="file_btn"><i class="el-icon-upload"></i><span
                v-text="uploadView.label">上传文件</span></el-button>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="uploadView.show = false">取 消</el-button>
        <el-button type="primary" @click="updateFile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Item from '../../../form/Item'
import mixCalculator from '../../formDesigner/packages/config/calculator/mixCalculator'
import mixExtMenu from './mixins/extMenu'
import mixinRowInit from '../../../form/components/mixins/rowInit'
import Form from '../../../form/Form'
import { searchMethod } from './dynamicSearch'
import mixMergeCell from './mixins/mergeCell'
import mixFilters from './mixins/filters'
// import Filters from './filters.vue'
import {
  havaCustomFunction
} from '@/workFlow/utils/flowUtils'
export default {
  inject: ['viewFormData', 'parentContentItems'],
  mixins: [mixCalculator, mixExtMenu, mixinRowInit, mixMergeCell, mixFilters],
  name: 'DynamicForm2',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    children: {
      type: Object
    },
    column: {
      type: Object
    }
  },
  components: {
    Item,
    Form
    // Filters
  },
  data() {
    // const dynamicProp = this.column.prop
    // const tableColumn = this.viewFormData.modelData[dynamicProp] || []
    const {
      menuWidth,
      disabled,
      searchShow
    } = this.column
    return {
      uploadView: {
        show: false,
        label: '上传文件',
        form: {}
      },
      tableColumn: [],
      currentIndex: -1,
      condition: {},
      menuWidth: menuWidth || 150,
      searchShow: !!searchShow,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      setValue: 0,
      isViewPage: disabled
    }
  },
  computed: {
    expandColumn() {
      return this.children.column.filter(item => item.isExpand)
    },
    items() {
      return this.children.column.filter(item => item.display && !item.hide)
    },
    isPage() {
      return this.page.total > this.page.pageSize
    },
    searchItems() {
      return _.filter(this.items, { isSearch: true })
    },
    addBtn() {
      return this.column.allowAdd
    },
    delBtn() {
      return this.column.allowDel
    }
  },
  watch: {
    tableColumn(v, oldV) {
      // console.log(v, 'tableColumn')
      // this.viewFormData.modelData = v
      // console.log(this.viewFormData.modelData, this.column.prop)
    },
    value(val, oldVal) {
      this.reLoadPage()
    },
    setValue(val, oldVal) {
      if (val !== oldVal) {
        this.reLoadPage()
      }
    }
  },
  beforeDestroy() {
    this.scrollboadHandle && clearInterval(this.scrollboadHandle)
  },
  mounted() {
    this.reLoadPage()
    if (this.column.rate) {
      this.scrollboadHandle = setInterval(() => {
        this.refreshData()
      }, this.column.rate * 1000)
    }
  },
  methods: {
    refreshData() {
      if (!this.viewFormData.modelData.id) {
        return
      }
      this.$http.get('/form-instance/select-sub-data',
        { params: { dataId: this.viewFormData.modelData.id, formId: this.viewFormData.options.formId, subProp: this.column.prop } }
      ).then(res => {
        if (this.value.length > 0) {
          this.value.splice(0, this.value.length)
        }
        res.data.subData.forEach(subItemData => {
          this.value.push(subItemData)
        })
        // this.value = [{ name: '翁绍辉' }, { name: '张大神' }]
        this.reLoadPage()
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    reLoadPage(offset = null, maxSize = null) {
      this.value.forEach(item => {
        delete item['alwayShowItem_']
      })
      const searchColumn = this.value.filter(item => searchMethod(item, this.column, this.condition))
      this.page.total = searchColumn.length
      const {
        pageSize,
        currentPage
      } = this.page
      if (offset === null) {
        offset = (currentPage - 1) * pageSize
      }
      if (maxSize === null) {
        maxSize = (offset + pageSize) > this.page.total ? this.page.total : (offset + pageSize)
      }
      this.tableColumn = searchColumn.slice(offset, maxSize)
    },
    handleSearch(vals) {
      console.log(vals)
      this.condition = vals
      this.page.currentPage = 1
      setTimeout(() => {
        this.reLoadPage(0, this.page.pageSize)
      }, 500)
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      setTimeout(() => {
        this.reLoadPage()
      }, 100)
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      setTimeout(() => {
        this.reLoadPage()
      }, 100)
    },
    handleShowForm() {
      this.searchShow = !this.searchShow
    },
    handleClick(scope) {
      console.log(scope)
    },
    handleRowEdit(val, key, index, item) {
      const row = this.tableColumn[index]
      row[key] = val
      row.alwayShowItem_ = true

      const currentIndex = _.findIndex(this.value, row)
      this.value.splice(currentIndex, 1, {
        ...row
      })

      if (this.contentIncludes(`${this.column.prop}.${item.prop}`)) {
        this.runFormData2(this.column.prop)
      }

      const {
        customEvent,
        customEventName
      } = item

      if (customEvent) {
        if (havaCustomFunction(customEventName)) {
          window.workFlow[customEventName].bind(
            this,
            {
              value: val,
              column: item
            },
            row,
            this.viewFormData,
            this.children,
            (newRow, modelData) => {
              if (newRow) {
                this.value.splice(currentIndex, 1, {
                  ...newRow
                })
              }

              if (modelData) {
                setTimeout(() => {
                  this.viewFormData.modelData = modelData
                }, 500)
              }
            }
          )() // params, eg addTest2: e, changeModelValue, viewFormData, children, done
        }
      }
    },
    handleRowDel(index) {
      const row = this.tableColumn[index]
      const currentIndex = _.findIndex(this.value, row)
      this.runFormData2(this.column.prop)
      this.value.splice(currentIndex, 1)

      const {
        beforeRowDeleteFunctionName
      } = this.column

      if (beforeRowDeleteFunctionName) {
        if (havaCustomFunction(beforeRowDeleteFunctionName)) {
          window.workFlow[beforeRowDeleteFunctionName].bind(
            this,
            {
              value: null,
              column: this.column
            },
            this.viewFormData,
            this.children,
            (newRow, modelData) => {
              if (modelData) {
                setTimeout(() => {
                  this.viewFormData.modelData = modelData
                }, 500)
              }
            }
          )()
        }
      }
    },
    handleRowAdd() {
      const row = this.row()
      const def = this.defaultValueSet()

      const {
        beforeRowSaveFunctionName
      } = this.column
      if (beforeRowSaveFunctionName) {
        if (havaCustomFunction(beforeRowSaveFunctionName)) {
          window.workFlow[beforeRowSaveFunctionName].bind(
            this,
            {
              value: null,
              column: this.column
            },
            row,
            this.viewFormData,
            this.children,
            (newRow, modelData) => {
              if (newRow) {
                this.value.push(newRow)
              }
              if (modelData) {
                setTimeout(() => {
                  this.viewFormData.modelData = modelData
                }, 500)
              }
            }
          )()
        }
      } else {
        this.value.push({
          ...row,
          ...def
        })
      }
    },
    row() {
      let obj = {}
      obj.alwayShowItem_ = true
      obj = this.initRow(obj)
      return obj
    },
    sortChange(a, b) {
      // not work
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe {
  width: 100%;
  border: 0;
  overflow: hidden;
  box-sizing: border-box;
}
$disabledColor: #606266;
:deep(.el-table th) {
  word-break: break-word;
  color: rgba(0, 0, 0, 0.85);
  background-color: #fafafa;
  padding: 5px 0;
}
.btns {
  padding-bottom: 10px;
  display: flex;
  .l {
    flex: 1;
    .title {
      font-weight: 600;
    }
  }
  .r {
    margin-right: 10px;
  }
}
.empty {
  line-height: 180%;
}
.dynamic {
  position: relative;
  :deep(
      .el-input.is-disabled .el-input__inner,
      .el-range-editor.is-disabled,
      .el-range-editor.is-disabled input,
      .el-textarea.is-disabled .el-textarea__inner
    ) {
    background-color: transparent;
    border-color: transparent;
    color: $disabledColor;
  }
  :deep(.el-textarea.is-disabled .el-textarea__inner) {
    resize: none;
  }
  :deep(
      .el-input.is-disabled .el-input__icon,
      .is-disabled .el-input-number__decrease,
      .is-disabled .el-input-number__increase
    ) {
    display: none;
  }
  :deep(
      .is-disabled + span.el-checkbox__label,
      .is-disabled + span.el-radio__label
    ) {
    color: $disabledColor;
  }
  :deep(
      .el-radio__input.is-disabled .el-radio__inner,
      .el-checkbox__input.is-disabled .el-checkbox__inner
    ) {
    background-color: #fff;
    border-color: $disabledColor;
  }
  :deep(.el-radio__input.is-disabled.is-checked .el-radio__inner::after) {
    background-color: $disabledColor;
  }
  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after) {
    border-color: $disabledColor;
  }
  :deep(.el-table__body td) {
    // vertical-align: top;
    text-align: left;
  }
}
.content {
  max-width: 500px;
}
.cell2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 40px;
}
.file {
  z-index: 999;
  opacity: 0;
  position: absolute;
  left: 2px;
  width: 8.75rem;
  cursor: pointer;
  height: 2.75rem;
}
.file_btn {
  position: absolute;
  left: 2px;
  width: auto;
  z-index: 0;
}
</style>
